import { render, staticRenderFns } from "./admin-exam-questions.vue?vue&type=template&id=48bfd37a&scoped=true"
import script from "./admin-exam-questions.vue?vue&type=script&lang=js"
export * from "./admin-exam-questions.vue?vue&type=script&lang=js"
import style0 from "./admin-exam-questions.vue?vue&type=style&index=0&id=48bfd37a&prod&lang=scss&scoped=true"
import style1 from "./admin-exam-questions.vue?vue&type=style&index=1&id=48bfd37a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bfd37a",
  null
  
)

export default component.exports